<template>
    <div class="d-flex align-items-center">
        <span
            :class="contract.image"
            :aria-label="contract.offerLabel"
            class="item-icon"
            aria-hidden="true"
        />
        <div class="item-container">
            <div class="item-text">
                <span v-html="contract.offerLabel" />
                <small class="item-desc" v-html="phoneNumber" />
            </div>
            <div v-if="contract.rerouting && contract.enabled" class="ob1-tooltip">
                <span :aria-describedby="'tooltip-item-status-' + contract.id" class="ob1-tooltip-trigger item-status icon-info" />
                <div :id="'tooltip-item-status-' + contract.id" class="ob1-tooltip-content ob1-tooltip-right">
                    <p v-html="contract.rerouting.messageDescription" />
                </div>
                <div class="ob1-tooltip-shadow" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: {
    phoneNumber: function () {
      return PhoneFormatter.toFrench(this.contract.phoneNumber);
    },
  }
}
</script>
